// https://github.com/reeko/prevent-window-opener-attacks
import 'prevent-window-opener-attacks';
